if ($('.desktop.type-detail .variant-list').length) {

  $(document).ready(function () {

    const $targets = $('.advanced-parameter-inner:has(img)');

    $targets
      .removeAttr('title')
      .removeAttr('data-original-title')
      .removeAttr('aria-describedby');

    // odstranění existujících tooltipů z DOM
    $('.tooltip').remove();

    // bezpečné zrušení tooltip pluginu, pokud existuje
    if ($.fn.tooltip) {
      try {
        $targets.tooltip('destroy');
      } catch (e) {
        // Shoptet / Bootstrap verze nemusí destroy podporovat
      }
    }

  });

  // vložíme preview 1×
  if (!$('#variant-hover-preview').length) {
    $('body').append('<div id="variant-hover-preview" style="display:none"></div>');
  }

  $(document).on('mouseenter', '.advanced-parameter', function () {

    const $preview = $('#variant-hover-preview');
    const $el = $(this);
    const $variantList = $el.closest('.variant-list');

    let content = '';

    if (window.shoptet?.variantsSplit?.necessaryVariantData) {

      const paramId = $variantList.find('.hidden-split-parameter').data('parameter-id');
      const valueId = $el.find('input').val();

      let selected = {};

      $('.variant-list').each(function () {

        const $list = $(this);
        const p = $list.find('.hidden-split-parameter').data('parameter-id');

        let v;

        if ($list.is($variantList)) {
          v = valueId;
        } else {
          v = $list.find('input:checked').val();
        }

        if (p && v) {
          selected[p] = v;
        }

      });

      const key = Object.entries(selected)
        .sort((a, b) => Number(a[0]) - Number(b[0]))
        .map(([p, v]) => `${p}-${v}`)
        .join('-');

      const variant = shoptet.variantsSplit.necessaryVariantData[key];

      if (variant?.variantImage?.big) {
        content = `<img src="${variant.variantImage.big}" style="object-fit:cover;border-radius:12px;">`;
      }

    }

    if (!content) {

      const $img = $el.find('img');

      if ($img.length) {

        const src = $img.attr('data-src') || $img.attr('src');

        content = `<img src="${src}" style="object-fit:cover;border-radius:12px;">`;

      } else {

        const $inner = $el.find('.advanced-parameter-inner');
        const bgColor = $inner.css('background-color');

        content = `<div style="width:100%;height:100%;background:${bgColor};border-radius:12px;"></div>`;

      }

    }

    $preview.html(content);

    const offset = $el.offset();
    const width = $el.outerWidth();

    $preview.css({
      position: 'absolute',
      top: offset.top - 175,
      left: offset.left + width / 2 - 100 + 22,
      display: 'block'
    });

  });

  $(document).on('mouseleave', '.advanced-parameter', function () {
    $('#variant-hover-preview').hide();
  });

}